export const actionChangeInputsPageContactUs = (name,value) => ({
    type: 'CHANGE_INPUTS_PAGE_CONTACT_US',name,value
});